import React from 'react'
import PropTypes from 'prop-types'
import { Fade } from '@material-ui/core/'

const Fader = ({ children, style }) => {
  return <div style={style}>{children}</div>
}
Fader.propTypes = {
  children: PropTypes.any,
  style: PropTypes.any,
}

const FadeWrapper = ({ expanded, timeout, ...rest }) => {
  return (
    <Fade
      in={!!expanded}
      timeout={timeout ? timeout : 1000}
    >
      <Fader {...rest} />
    </Fade>
  )
}
FadeWrapper.propTypes = {
  expanded: PropTypes.any.isRequired,
  timeout: PropTypes.number,
  children: PropTypes.any,
}

export default FadeWrapper
